import(/* webpackMode: "eager", webpackExports: ["Analytics"] */ "/vercel/path0/node_modules/@vercel/analytics/dist/react/index.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/node_modules/holy-loader/dist/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["SessionProvider"] */ "/vercel/path0/node_modules/next-auth/react.js");
;
import(/* webpackMode: "eager", webpackExports: ["ThemeProvider"] */ "/vercel/path0/node_modules/next-themes/dist/index.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["ViewTransitions"] */ "/vercel/path0/node_modules/next-view-transitions/dist/index.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/font/google/target.css?{\"path\":\"src/components/layouts/root-layout.tsx\",\"import\":\"Noto_Serif\",\"arguments\":[{\"weight\":[\"400\",\"500\",\"600\",\"700\"],\"style\":[\"normal\",\"italic\"],\"subsets\":[\"latin\"],\"variable\":\"--font-serif\"}],\"variableName\":\"fontSerif\"}");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/font/google/target.css?{\"path\":\"src/components/layouts/root-layout.tsx\",\"import\":\"Space_Grotesk\",\"arguments\":[{\"display\":\"swap\",\"subsets\":[\"latin\"],\"variable\":\"--font-sans\"}],\"variableName\":\"fontSans\"}");
;
import(/* webpackMode: "eager", webpackExports: ["usePageTrackerStore"] */ "/vercel/path0/node_modules/react-page-tracker/dist/page-tracker-store.js");
;
import(/* webpackMode: "eager", webpackExports: ["PageTracker"] */ "/vercel/path0/node_modules/react-page-tracker/dist/page-tracker.js");
;
import(/* webpackMode: "eager", webpackExports: ["ErrorToast"] */ "/vercel/path0/src/components/primitives/error-toast.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["WebVitals"] */ "/vercel/path0/src/components/primitives/web-vitals.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Toaster"] */ "/vercel/path0/src/components/ui/sonner.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TooltipProvider"] */ "/vercel/path0/src/components/ui/tooltip.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PostHogProvider"] */ "/vercel/path0/src/lib/posthog/posthog-provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TRPCReactProvider"] */ "/vercel/path0/src/lib/trpc/react.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/styles/globals.css");
